module.exports = __webpack_public_path__ + "media/site/images/startups/development-figure-a1dcdbd605920b7f7423d97dff8b8c77.svg";